<div *ngIf="isOpen" class="acm-backdrop" (click)="onClose()" aria-modal="true" role="dialog"
  aria-labelledby="acm-title">
  <div class="acm-card" (click)="onContentClick($event)">
    <div class="acm-header">
      <div class="acm-header__left">
        <div class="acm-header__icon">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="#de7141">
            <path
              d="M21 18v1c0 1.1-.9 2-2 2H5c-1.11 0-2-.9-2-2V5c0-1.1.89-2 2-2h14c1.1 0 2 .9 2 2v1h-9c-1.11 0-2 .9-2 2v8c0 1.1.89 2 2 2h9zm-9-2h10V8H12v8zm4-2.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z" />
          </svg>
        </div>
        <div>
          <h6 id="acm-title" class="acm-header__title">Add credits</h6>
          <p class="acm-header__sub">1 credit = 1 signed document</p>
        </div>
      </div>
      <button class="acm-close" (click)="onClose()" aria-label="Close">✕</button>
    </div>
    <form [formGroup]="form" (ngSubmit)="onRecharge()">
      <div class="acm-body">
        <div class="acm-presets">
          <button *ngFor="let preset of presets" type="button" class="acm-preset-btn"
            [class.acm-preset-btn--active]="selectedPreset?.credits === preset.credits" (click)="selectPreset(preset)">
            <span class="acm-preset-btn__credits">{{ preset.credits }}</span>
            <span class="acm-preset-btn__label">credits</span>
            <span class="acm-preset-btn__amount">₹{{ preset.amount }}</span>
          </button>
        </div>
        <div class="acm-divider">
          <span>Or enter a custom amount</span>
        </div>
        <div class="acm-input-wrap"
          [class.acm-input-wrap--error]="form.get('amount')?.invalid && form.get('amount')?.touched">
          <span class="acm-input-prefix">₹</span>
          <input type="number" formControlName="amount" class="acm-input" placeholder="Enter amount in ₹" min="10"
            autocomplete="off" (input)="onCustomInput()" />
        </div>
        <div class="acm-field-error" *ngIf="form.get('amount')?.invalid && form.get('amount')?.touched">
          <ng-container *ngIf="form.get('amount')?.errors?.['required']">Amount is required.</ng-container>
          <ng-container *ngIf="form.get('amount')?.errors?.['min']">Minimum amount is ₹{{ RATE }} (1
            credit).</ng-container>
          <ng-container *ngIf="form.get('amount')?.errors?.['multipleOf']">Only multiples of ₹{{ RATE }} are allowed.</ng-container>
        </div>
        <div class="acm-preview" *ngIf="creditsPreview > 0">
          <span class="acm-preview__label">You'll get</span>
          <span class="acm-preview__credits">{{ creditsPreview }} credit{{ creditsPreview !== 1 ? 's' : '' }}</span>
        </div>
      </div>
      <div class="acm-footer">
        <button type="submit" class="acm-recharge-btn" [disabled]="!canSubmit || isLoading">
          <span *ngIf="isLoading" class="acm-btn-spinner"></span>
          <span *ngIf="!isLoading">Recharge ₹ {{ amountValue || 0 }} →</span>
          <span *ngIf="isLoading">Processing…</span>
        </button>
      </div>
    </form>
  </div>
</div>
<ng-template #paymentModal let-modal>
  <div class="modal-header popupHeader">
    <h6>Payment</h6>
    <img (click)="closePaymentModal()" class="usersFilter__crossIcon cursor-pointer"
      src="assets/images/user-management/Cross.svg" alt="close" />
  </div>
  <div class="modal-body p-0" style="overflow: hidden;">
    <iframe *ngIf="paymentUrl" [src]="paymentUrl" width="100%" height="700px" style="display: block; border: none;"
      title="Razorpay Payment"></iframe>
  </div>
</ng-template>
<app-success-toaster *ngIf="showSuccessToaster" [title]="successMessage"
  (closeToaster)="closeToaster('success')"></app-success-toaster>
<app-error-toaster *ngIf="showErrorToaster" [title]="errorMessage"
  (closeToaster)="closeToaster('error')"></app-error-toaster>